import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAXlZnDS2tpZ_CiiRGss6j7L2Sz3d3chek",
  authDomain: "koordinap-dvdbukovac.firebaseapp.com",
  projectId: "koordinap-dvdbukovac",
  storageBucket: "koordinap-dvdbukovac.firebasestorage.app",
  messagingSenderId: "32294754655",
  appId: "1:32294754655:web:e502eb69ac358097d93eea"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const VAPID_KEY = 'BNxFIYlR6ha72BM8JJ2BPnvEZpZtDp1Oge0EXKP679zz2UUFLRhDIm9CPFlNTcOS4FcDBe9RpO7fYA27nOSUgCY';

async function getSwRegistration() {
  const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
  if (reg.active) return reg;
  const sw = reg.installing || reg.waiting;
  if (!sw) return reg;
  return new Promise((resolve, reject) => {
    sw.addEventListener('statechange', function handler() {
      if (sw.state === 'activated') {
        sw.removeEventListener('statechange', handler);
        resolve(reg);
      } else if (sw.state === 'redundant') {
        sw.removeEventListener('statechange', handler);
        reject(new Error('Service worker nije aktiviran — moguć CSP problem (importScripts gstatic.com)'));
      }
    });
  });
}

export async function requestPushPermission() {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.log('[PUSH] Dozvola odbijena:', permission);
    return null;
  }
  const swReg = await getSwRegistration();
  const existingSub = await swReg.pushManager.getSubscription();
  if (existingSub) await existingSub.unsubscribe();
  const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swReg });
  if (token) console.log('[PUSH] Token dobiven.');
  return token || null;
}

export async function refreshPushToken() {
  const swReg = await getSwRegistration();
  const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swReg });
  return token || null;
}

export function onForegroundMessage(callback) {
  return onMessage(messaging, callback);
}

export { messaging };
